import React, {useState} from "react";
import {
    createSendsPage, SendsPageDataType,
    SendsPagesUpdateType,
    useUpdateSendsData
} from "../../../Api/StandaloneSendsEndpoints";
import CreateStandaloneSendForm from "../../../Components/Sends/CreateStandaloneSendsForm";
import SendsAdminNavigation from "../../../Components/Sends/SendsAdminNavigation";
import BasicPageHeader from "../../../Framework/Components/LayoutScaffold/BasicPageHeader";
import FullWidthSidebar from "../../../Framework/Components/PageLayouts/FullWidthSidebar";
import {ColourMod} from "../../../Framework/Data/Enums/LayoutEnums";
import {useToasts} from "../../../Framework/Providers/ToastsProvider";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { faFloppyDisk } from "@fortawesome/pro-solid-svg-icons";
import {useLayout} from "../../../Framework/Providers/LayoutProvider";

const CreateSendsPage = () => {
    const { addToast } = useToasts();
    const sendsTemplates = useUpdateSendsData();
    const { isLarge } = useLayout();

    const [ savingData, setSavingData] = useState<boolean>(false);
    const [ saveError, setSaveError] = useState<any>();
    const [ saveResp, setSaveResp ] = useState(null);

    const HandleSave = async (newData: SendsPageDataType) => {
        setSavingData(true);

        await createSendsPage(newData)
            .then((resp: any) => {
                sendsTemplates.mutate({
                    updateType: SendsPagesUpdateType.CREATE,
                    newData: newData
                });

                addToast('Sends Profile Created!', <FontAwesomeIcon icon={faFloppyDisk} />, ColourMod.Success);
                setSaveResp(resp);
            })
            .catch((e: any) => {
                setSaveError(e.response.data);
            })
            .finally(() => setSavingData(false));
    }

    return (
        <FullWidthSidebar
            navigationComponent={
                <SendsAdminNavigation
                    title={'Creating Sends Profile'}
                />
            }
            extraContentClass={`flex-column `}
        >
            {isLarge && (
                <BasicPageHeader title={'Creating Sends Profile'} />
            )}

            <div className={'pt-xl pb-xl p-md'}>
                <div className={'row mb-xxxl'}>

                    <div className={'col-xs-12 col-xl-6 col-xxl-5 '}>
                        <CreateStandaloneSendForm
                            saveCallback={HandleSave}
                            saveResponse={saveResp}
                            savingData={savingData}
                            error={saveError}
                        />
                    </div>

                </div>
            </div>

        </FullWidthSidebar>
    )
}

export default CreateSendsPage
